import { Component, OnDestroy, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Subscription } from "rxjs/Subscription";
import { AppMemoryService } from "../../core/app-memory.service";
import { GetService } from "../../core/get.service";
import {
  usaRegionBC,
  usaRegionBC2023,
  usaRegionCA,
  usaRegionKY,
  usaRegionPC,
  usaRegionPK,
} from "../../models/Regions";

@Component({
  selector: "app-rule-book",
  templateUrl: "./rule-book.component.html",
  styleUrls: ["./rule-book.component.less"],
})
export class RuleBookComponent implements OnInit, OnDestroy {
  public pdfSrc = "";
  public banner: string = null;
  public ruleBook: Region;
  public regions: Region[] = [];
  public regionsSub: Subscription;
  public user: User;

  public currentCountry = environment.currentCountry;
  public isUkCountry = this.currentCountry.toLowerCase() === "uk";
  public isIECountry = this.currentCountry.toLowerCase() === "ie";
  public isUSCountry = this.currentCountry.toLowerCase() === "us";

  constructor(
    public appMemory: AppMemoryService,
    private getService: GetService
  ) {}

  async ngOnInit() {
    this.user = await this.getService.getUser();
    this.regionsSub = await this.appMemory.regions.subscribe(
      async (regions) => {
        if (regions) {
          regions.forEach((e) => {
            e.text = e.name;
          });
          this.regions = regions;
        }
      }
    );

    var regionIdList = [];
    this.user.organization.farms.forEach((e) => {
      regionIdList.push(e.region);
    });

    if (this.isUkCountry || this.isIECountry)
      this.getPdf(this.user.organization.farms[0].region);

    if (this.isUSCountry)
      this.getUsPdf(regionIdList);
  }

  ngOnDestroy() {
    if (this.regionsSub) {
      this.regionsSub.unsubscribe();
    }
  }

  changeSelection(e) {
    this.ruleBook = e;
    if (this.isUkCountry || this.isIECountry) this.getPdf(e.id);
    if (this.isUSCountry) this.getUsPdf([e.id]);
  }

  getPdf(region: string) {
    if (environment.country === "usa" && region) {
      switch (region) {
        case usaRegionBC2023:
          this.pdfSrc = environment.ruleBookBC2023Pdf;
          this.banner = "";
          break;
        case usaRegionKY:
          this.pdfSrc = environment.ruleBookKYPdf;
          this.banner =
            "Please refer to the Kentucky Horse Racing Commission Withdrawal Guidelines found in: " +
            "<a href='http://khrc.ky.gov/Pages/default.aspx' target='_blank'>http://khrc.ky.gov/Pages/default.aspx</a>";
          break;
        case usaRegionCA:
          this.pdfSrc = environment.ruleBookCAPdf;
          this.banner =
            "Please refer to the California Horse Racing Board Withdrawal Guidelines found in: " +
            "<a href='http://www.chrb.ca.gov/rule_law/RuleBook/chrb_rule_book_06302020.pdf' " +
            "target='_blank'>http://www.chrb.ca.gov/rule_law/RuleBook/chrb_rule_book_06302020.pdf</a>";
          break;
        case usaRegionBC:
          this.pdfSrc = environment.ruleBookBCPdf;
          this.banner =
            "For more information about the Breeders Cup you can visit their website here: " +
            "<a href='http://www.breederscup.com' " +
            "target='_blank'>www.breederscup.com</a>";
          break;
        default:
          this.pdfSrc = null;
      }
    } else {
      this.pdfSrc = environment.ruleBookPdf;
    }
  }

  getUsPdf(regions: string[]) {
    if (environment.country === "usa" && regions) {
      if (regions.includes(usaRegionBC2023)) {
        this.pdfSrc = environment.ruleBookBC2023Pdf;
        this.banner = "";
        return;
      }
      if (regions.includes(usaRegionBC)) {
        this.pdfSrc = environment.ruleBookBCPdf;
        this.banner =
          "For more information about the Breeders Cup you can visit their website here: " +
          "<a href='http://www.breederscup.com' " +
          "target='_blank'>www.breederscup.com</a>";
        return;
      }
      if (regions.includes(usaRegionPK)) {
        this.pdfSrc = environment.ruleBookPKPdf;
        this.banner =
          "For more information about the Preakness you can visit their website here: " +
          "<a href='https://www.preakness.com/' " +
          "target='_blank'>www.preakness.com</a>";
        return;
      }
      if (regions.includes(usaRegionPC)) {
        this.pdfSrc = environment.ruleBookPCPdf;
        this.banner =
          "For more information about the Pegasus World Cup you can visit their website here: " +
          "<a href='https://www.pegasusworldcup.com/' " +
          "target='_blank'>www.pegasusworldcup.com</a>";
        return;
      }
    }
    this.pdfSrc = environment.ruleBookPdf;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/rule-book/rule-book.component.ts